// 客服：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 客服界面
export const ui = Object.freeze({
  "agentServiceUI.answerElapsed": "總用時 {duration}",
  "agentServiceUI.answerSeconds": "{seconds}秒",
  "agentServiceUI.answerMinutes": "{minutes}分{seconds}秒",
  "agentServiceUI.copyAnswer": "複製回答",
  "agentServiceUI.answerCopied": "已複製",
  "agentServiceUI.answerCopyFailed": "複製失敗，請選取文字後複製",
  "agentServiceUI.supplyDemandCardExpand": "展開貨物資料",
  "agentServiceUI.supplyDemandCardCollapse": "收起貨物資料",
  "agentServiceUI.supplyDemandCardToggleHint":
    "連按兩下卡片可展開或收起貨物資料",
  "agentServiceUI.supplyDemandCardUnavailable":
    "貨物資料暫時無法顯示，請重新開啟此資訊",
  "agentServiceUI.supplyDemandField.goodsType": "晶片類型",
  "agentServiceUI.supplyDemandScene": "供需資訊",
  "agentServiceUI.supplyDemandCardDetails": "查看本次貨物資料",
  "agentServiceUI.supplyDemandSupply": "供應",
  "agentServiceUI.supplyDemandDemand": "求購",
  "agentServiceUI.supplyDemandField.infoNumber": "資訊編號",
  "agentServiceUI.supplyDemandField.clueType": "供需類型",
  "agentServiceUI.supplyDemandField.partNumber": "產品料號",
  "agentServiceUI.supplyDemandField.goodsName": "產品名稱",
  "agentServiceUI.supplyDemandField.goodsTitle": "產品標題",
  "agentServiceUI.supplyDemandField.goodsBrand": "產品品牌",
  "agentServiceUI.supplyDemandField.goodsPrice": "產品單價",
  "agentServiceUI.supplyDemandField.goodsPriceUnit": "幣種",
  "agentServiceUI.supplyDemandField.goodsQuantity": "產品數量",
  "agentServiceUI.supplyDemandField.goodsUnit": "數量單位",
  "agentServiceUI.supplyDemandField.manufactureDate": "貨物批次",
  "agentServiceUI.supplyDemandField.usageScenario": "貨物情況",
  "agentServiceUI.supplyDemandField.deliveryAddress": "貨源所在地",
  "agentServiceUI.supplyDemandField.goodsCategoryName": "產品分類",
  "agentServiceUI.supplyDemandField.categoryAttributes": "分類屬性",
  "agentServiceUI.supplyDemandField.goodsImage": "圖片",
  "agentServiceUI.supplyDemandField.pictures": "圖片清單",
  "agentServiceUI.supplyDemandField.specificationUrl": "規格書",
  "agentServiceUI.supplyDemandField.originCertificate": "原產地證明",
  "agentServiceUI.supplyDemandField.manufacturer": "製造商",
  "agentServiceUI.supplyDemandField.weight": "重量",
  "agentServiceUI.supplyDemandField.length": "長",
  "agentServiceUI.supplyDemandField.width": "闊",
  "agentServiceUI.supplyDemandField.height": "高",
  "agentServiceUI.supplyDemandField.goodsBuyMinQty": "最低訂購量",
  "agentServiceUI.supplyDemandField.substitutes": "替代",
  "agentServiceUI.supplyDemandField.applications": "應用",
  "agentServiceUI.supplyDemandField.goodsPeriod": "有效期",
  "agentServiceUI.supplyDemandField.deliveryPeriod": "交貨日數",
  "agentServiceUI.supplyDemandField.traderCompany": "貨主公司",
  "agentServiceUI.supplyDemandField.remark": "備註",
  "agentServiceUI.supplyDemandField.productType": "產品類型",
  "agentServiceUI.supplyDemandField.capacity": "容量",
  "agentServiceUI.supplyDemandField.architecture": "架構",
  "agentServiceUI.supplyDemandField.speed": "速率",
  "agentServiceUI.supplyDemandField.ball": "球位",
  "agentServiceUI.moveGrip": "移動聊天小窗，支持拖動與方向鍵",
  "agentServiceUI.resizeHandle":
    "調節聊天窗口大小（{direction}），支持方向鍵",
  "agentServiceUI.headerGrip": "聊天標題欄，可拖動或使用方向鍵移動窗口",
  "agentServiceUI.online": "在線",
  "agentServiceUI.offline": "離線",
  "agentServiceUI.closeChat": "關閉聊天",
  "agentServiceUI.dockLeft": "收納對話到左側",
  "agentServiceUI.dockRight": "收納對話到右側",
  "agentServiceUI.restoreChat": "展開客服對話，可拖動或使用方向鍵移動懸浮球",
  "agentServiceUI.onlineSupport": "在線客服",
  "agentServiceUI.chatDialog": "客服聊天",
  "agentServiceUI.messageInput": "聊天訊息",
  "agentServiceUI.sendMessage": "發送訊息",
  "agentServiceUI.send": "發送",
  "agentServiceUI.composerPlaceholder": "輸入訊息，按 Enter 發送",
  "agentServiceUI.handoffRequested": "客戶請求真人服務",
  "agentServiceUI.handoffHint": "接受後由您直接回復；拒絕則恢復 Agent。",
  "agentServiceUI.rejectHandoff": "拒絕接管",
  "agentServiceUI.acceptHandoff": "接管會話",
  "agentServiceUI.generalTitle": "XSOU 客服",
  "agentServiceUI.generalDialog": "總客服",
  "agentServiceUI.connectingSupport": "正在連接客服",
  "agentServiceUI.reload": "重新載入",
  "agentServiceUI.generalEmpty": "採購詢價、平台使用、售後與企業認證",
  "agentServiceUI.connecting": "正在連接",
  "agentServiceUI.loginRequired": "請先登入後使用客服。",
  "agentServiceUI.loginIdentityMissing":
    "未能獲取登入身份，請重新登入後使用客服。",
  "agentServiceUI.realtimePolling": "實時連接暫不可用，正在定時補讀訊息。",
  "agentServiceUI.requestFailed": "客服請求失敗，請重試。",
  "agentServiceUI.orderDialog": "訂單客服",
  "agentServiceUI.creatingConversation": "正在建立客服會話",
  "agentServiceUI.orderScene": "訂單 {orderNum}",
  "agentServiceUI.waitingForStaff": "等待業務員接管",
  "agentServiceUI.cannotSend": "當前狀態不能發送訊息",
  "agentServiceUI.loadFailed": "客服會話載入失敗",
  "agentServiceUI.realtimeUnavailable":
    "實時連接暫時不可用，仍可繼續收發訊息",
  "agentServiceUI.recoveryReadFailed": "實時恢復後的訊息補讀失敗",
  "agentServiceUI.sendFailed": "訊息發送失敗",
  "agentServiceUI.retryFailed": "訊息重試失敗",
  "agentServiceUI.controlUpdateFailed": "會話狀態更新失敗",
  "agentServiceUI.conversationLanguage": "對話語言",
  "agentServiceUI.toggleTranslationMode": "切換單語或雙語展示",
  "agentServiceUI.singleMode": "單語",
  "agentServiceUI.bilingualMode": "雙語",
  "agentServiceUI.staffTranslationLanguage": "接待譯文：簡體中文",
  "agentServiceUI.selectConversationLanguage": "選擇對話語言",
  "agentServiceUI.customerLanguage": "客戶語言",
  "agentServiceUI.customerLanguageWith": "客戶：{language}",
  "agentServiceUI.closeLanguageList": "關閉語言列表",
  "agentServiceUI.conversationLanguageList": "對話語言列表",
  "agentServiceUI.retry": "重試",
  "agentServiceUI.language": "語言",
  "agentServiceUI.returnToReadPosition":
    "返回上次閲讀位置，期間有{count}條新訊息",
  "agentServiceUI.newMessageCount": "{count}條新訊息",
  "agentServiceUI.loading": "載入中",
  "agentServiceUI.viewOlderMessages": "查看更早訊息",
  "agentServiceUI.orderEmpty": "可以直接詢問庫存、交期、MOQ或商品資料",
  "agentServiceUI.translating": "翻譯中",
  "agentServiceUI.translationUnavailable": "譯文暫不可用",
  "agentServiceUI.aiReply": "AI回覆",
  "agentServiceUI.sending": "發送中",
  "agentServiceUI.sendFailedRetry": "發送失敗，點擊重試",
  "agentServiceUI.aiResponding": "{name}正在回覆",
  "agentServiceUI.statusTemporarilyUnavailable":
    "回覆狀態暫不可用，正在繼續等待…",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "messageCenter.messagesFailed": "訊息載入失敗",
  "messageCenter.sendFailed": "傳送失敗，請重試",
  "messageCenter.searchContacts": "搜尋聯絡人",
  "messageCenter.loadingConversations": "正在載入對話...",
  "messageCenter.conversationsFailed": "對話載入失敗",
  "messageCenter.noConversations": "暫無對話",
  "messageCenter.loadingMessages": "正在載入訊息...",
  "messageCenter.noMessages": "暫無訊息",
  "messageCenter.enterMessage": "輸入訊息",
});

// PC界面显示文案；不改动业务原值。
export const desktopMessageCenter = Object.freeze({
  "messageCenter.search": "搜尋",
  "messageCenter.generalSupport": "總客服",
  "messageCenter.orderSupport": "訂單客服",
  "messageCenter.aiEnabled": "已啟用",
  "messageCenter.aiDisabled": "未啟用",
  "messageCenter.aiAssistantLabel": "{name}的聊天助理{status}",
  "messageCenter.forgetLabel": "忘記與{name}相關的Agent諮詢記憶",
  "messageCenter.deleteLabel": "刪除與{name}的完整會話",
  "messageCenter.processing": "處理中",
  "messageCenter.forget": "忘記",
  "messageCenter.deleting": "刪除中",
  "messageCenter.delete": "刪除",
  "messageCenter.cancel": "取消",
  "messageCenter.image": "圖片",
  "messageCenter.file": "檔案",
  "messageCenter.composerPlaceholder":
    "輸入訊息...（Enter 傳送，Shift+Enter 換行）",
  "messageCenter.keyboardHint": "Enter 傳送，Shift+Enter 換行",
  "messageCenter.chooseConversation": "選擇左側會話開始聊天",
  "messageCenter.unavailable": "會話無法使用",
  "messageCenter.forgetTitle": "忘記諮詢記憶",
  "messageCenter.forgetConfirm":
    "只刪除Agent形成的諮詢記憶，聊天記錄仍保留。後續Agent不會再引用本次諮詢，確定繼續嗎？",
  "messageCenter.confirmForget": "確認遺忘",
  "messageCenter.forgotten": "本次諮詢記憶已遺忘，聊天記錄仍保留",
  "messageCenter.forgetFailed": "諮詢記憶遺忘失敗",
  "messageCenter.deleteTitle": "刪除會話",
  "messageCenter.deleteConfirm":
    "確定刪除與「{name}」的完整會話嗎？聊天記錄將從雙方訊息中心刪除；已形成的諮詢備忘會轉為唯讀歷史，不再更新。如需同時清除記憶，請先使用「忘記諮詢記憶」。",
  "messageCenter.deleted": "會話已刪除",
  "messageCenter.deleteFailed": "會話刪除失敗",
  "messageCenter.authMissing": "授權參數缺失，請重新授權",
  "messageCenter.wecomLoginFailed": "企業微信登入失敗",
  "messageCenter.wecomLoginError": "企業微信登入異常",
  "messageCenter.unknownUser": "未知用戶",
  "messageCenter.syncFailed": "客服訊息同步失敗，請稍後重試。",
  "messageCenter.aiUpdateFailed": "AI代聊狀態更新失敗",
  "messageCenter.yesterday": "昨天 {time}",
  "messageCenter.justNow": "剛剛",
  "messageCenter.minutesAgo": "{count}分鐘前",
  "messageCenter.hoursAgo": "{count}小時前",
  "messageCenter.operationFailed": "訂單客服操作失敗",
  "messageCenter.conversationMissing": "會話已不存在，請重新開啟客服視窗。",
  "messageCenter.conversationNotReady": "客服會話尚未建立",
  "messageCenter.sendingBusy": "訊息正在傳送，請稍候",
  "messageCenter.controlBusy": "客服控制狀態正在更新，請稍候",
  "messageCenter.emptyMessage": "訊息不可為空",
  "messageCenter.cannotSend": "目前會話狀態無法傳送訊息",
  "messageCenter.controlUpdateFailed": "客服控制狀態更新失敗",
  "messageCenter.networkBusy": "網絡繁忙請稍後再試",
});

export const messages = Object.freeze({
  ...desktopMessageCenter,
  ...mobileWorkflow,
  ...ui,
});
